export const GET_LANDING_INFO = 'GET_LANDING_INFO'
export const SET_REQUEST_USER_BOOKING = 'SET_REQUEST_USER_BOOKING'
export const GET_COMMONCODE_SPECIALITY = 'GET_COMMONCODE_SPECIALITY'
export const SET_MODAL_COMPONENT = 'SET_MODAL_COMPONENT'
export const SET_MODAL_REQUEST_COMPONENT = 'SET_MODAL_REQUEST_COMPONENT'
export const SET_MODAL_ALERT = 'SET_MODAL_ALERT'
export const SET_MODAL_ALERT_FOOTER = 'SET_MODAL_ALERT_FOOTER'
export const SET_GLOBAL_DROPDOWNMODEMENU = 'SET_GLOBAL_DROPDOWNMODEMENU'
export const SET_GLOBAL_DROPDOWNMODEBOX = 'SET_GLOBAL_DROPDOWNMODEBOX'
export const SET_SIGNUP = 'SET_SIGNUP'
export const GET_COMMONCODE_CITY = 'GET_COMMONCODE_CITY'
export const SET_GLOBAL_DROPDOWNMODE = 'SET_GLOBAL_DROPDOWNMODE'
export const SET_USERINFO = 'SET_USERINFO'
export const UPDATE_USERINFO = 'UPDATE_USERINFO'
export const GET_USERINFO = 'GET_USERINFO'
export const CHECK_LOGIN = 'CHECK_LOGIN'
export const LOGIN_OUT = 'LOGIN_OUT'
export const CLEAR_USER = 'CLEAR_USER'
export const UPDATE_USERINFO_TOKEN = 'UPDATE_USERINFO_TOKEN'
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST'
export const GET_SERVICE_DETAIL = 'GET_SERVICE_DETAIL'
export const GET_PHOTOGRAPHER_REQUEST = 'GET_PHOTOGRAPHER_REQUEST'
export const SET_PHOTOGRAPHER_REQUEST = 'SET_PHOTOGRAPHER_REQUEST'
export const POST_PHOTOGRAPHER_REQUEST = 'POST_PHOTOGRAPHER_REQUEST'
export const CLEAR_REQUEST_USER_BOOKING = 'CLEAR_REQUEST_USER_BOOKING'
export const SET_REQUEST_USER_DATE = 'SET_REQUEST_USER_DATE'
export const SAVE_REQUEST_USER_BOOKING = 'SAVE_REQUEST_USER_BOOKING'
export const SET_MODAL_GOOGLE_MAP_COMPONENT = 'SET_MODAL_GOOGLE_MAP_COMPONENT'
export const SET_SERVICE = 'SET_SERVICE'
export const RESET_SERVICE = 'RESET_SERVICE'
